import { useEffect } from "react";
import { ADMIN_LIST_DETAIL_RIGHT_PANEL_ID } from "../components/admin-list-detail-layout";

const MOBILE_BREAKPOINT_PX = 768;

/**
 * 모바일에서 단일 선택 시 상세(액션) 패널로 부드럽게 스크롤.
 * selectedItem이 truthy일 때만 실행, md 미만 뷰포트에서만 동작.
 */
export function useScrollToDetailPanelOnSelect(
  selectedItem: unknown,
  panelId: string = ADMIN_LIST_DETAIL_RIGHT_PANEL_ID
): void {
  useEffect(() => {
    if (!selectedItem) return;
    if (!window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT_PX - 1}px)`).matches)
      return;
    const el = document.getElementById(panelId);
    el?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [selectedItem, panelId]);
}
